import React from 'react';
import styled from 'styled-components';
import { Breakpoints, Grid } from '../../../app/StyleGuide';
import { PrimaryButton } from '../../../components/Buttons';
import { ButtonRow, Header, Subtitle, Title } from './ConnectChurchAccountModalElements';
import { SuccessCheckmarkIcon } from './SuccessCheckmarkIcon';

const SuccessContent = styled.div`
  flex: 1;
  display: grid;
  align-content: center;
  justify-items: center;
  gap: ${Grid._4};

  @media screen and (min-width: ${Breakpoints.screen_sm}) {
    gap: ${Grid._5};
  }
`;

type ConnectChurchAccountSuccessScreenProps = {
  dismissHandler: () => void;
};

export const ConnectChurchAccountSuccessScreen = ({ dismissHandler }: ConnectChurchAccountSuccessScreenProps) => (
  <>
    <SuccessContent>
      <SuccessCheckmarkIcon />
      <Header>
        <Title>Your account sync is complete</Title>
        <Subtitle>Thank you for helping us improve your experience across Lifeway websites!</Subtitle>
      </Header>
    </SuccessContent>

    <ButtonRow>
      <PrimaryButton onClick={dismissHandler} data-tracking-id="sync-church-account-success-close">
        Close
      </PrimaryButton>
    </ButtonRow>
  </>
);
